<div class="detail-overview-tests">
  <ng-container
    *ngFor="let evaluation of evaluations | keyvalue; let i = index"
  >
    <div class="data-chart" [ngClass]="{ 'mt-3': i > 0 }">
      <div class="row justify-content-between align-items-start mb-3 ms-xxl-7">
        <h2 class="fs-2 col-12 col-xl-5">
          <ng-container
            *appSkeletonLoader="loading; style: { height: '2.5rem' }"
          >
            {{ evaluation["value"]["title"] }}
          </ng-container>
        </h2>
        <div class="data-chart__evolutions col-12 col-xl-7 text-end">
          <ng-container
            *appSkeletonLoader="
              loading;
              style: { height: '1.7rem', width: '35%' }
            "
          >
            <div class="row flex-row-reverse">
              <div
                class="col-12 col-lg-6 py-2 text-uppercase justify-content-end text-end d-flex align-items-center"
                *ngFor="
                  let feature of evaluation['value']['features'];
                  let j = index
                "
              >
                {{ feature["title"] }}
                <span
                  class="fs-5 ms-3 me-2"
                  *ngIf="feature['progression'] === 0"
                >
                  <img src="assets/icons/icon_egal.svg"
                /></span>
                <span class="fs-5 ms-3 me-2" *ngIf="feature['progression'] > 0">
                  <img src="assets/icons/icon-arrow-up.svg"
                /></span>
                <span class="fs-5 ms-3 me-2" *ngIf="feature['progression'] < 0">
                  <img src="assets/icons/icon-arrow-down.svg"
                /></span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-chart
            [loading]="loading"
            [chartDatasets]="datasets[evaluation['key']]"
            [chartXLabels]="xLabels[evaluation['key']]"
            [chartDatasetFilter]="datasetFilters[evaluation['key']]"
            [chartHorizontalLimitLines]="
              evaluation['value']['horizontalLimitLines']
            "
            [showMeasuringPointsTotal]="false"
            [hasInteractiveLegend]="false"
          ></app-chart>
        </div>
      </div>
    </div>
  </ng-container>
</div>
